import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';


import { TranslateModule } from '@ngx-translate/core';
import { CustomDevelopmentsComponent } from './custom-developments/custom-developments.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { InternalCommunicationComponent } from './internal-communication/internal-communication.component';
import { PatientsComponent } from './patients/patients.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    RouterModule,
    TranslateModule
  ],
  declarations: [
    CustomDevelopmentsComponent,
    IntegrationsComponent,
    InternalCommunicationComponent,
    PatientsComponent
  ],
  exports: [
    CustomDevelopmentsComponent,
    IntegrationsComponent,
    InternalCommunicationComponent,
    PatientsComponent
  ],
  providers: []
})
export class SolutionsModule { }
